import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import StatusProgress from '../../../commonComponents/status/StatusProgress';
import OrderProp from '../propTypes/orderProp';
import DetailBlock from './DetailBlock';

function DetailHeader(props) {
  const { status, order, isOpportunity } = props;
  const { status: currentStatus } = order;
  return (
    <div className="m-portlet m-portlet__rounded order-detail-header">
      <StatusProgress
        status={status}
        currentStatus={currentStatus}
        isOpportunity={isOpportunity}
      />
      <DetailBlock isOpportunity={isOpportunity} item={order} />
    </div>
  );
}

DetailHeader.propTypes = {
  status: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string,
      text: PropTypes.string,
      order: PropTypes.number,
    }),
  ),
  order: PropTypes.shape(OrderProp.propType).isRequired,
  isOpportunity: PropTypes.bool,
};

DetailHeader.defaultProps = {
  status: [],
  isOpportunity: false,
};

export default translate(DetailHeader);
